import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import PassageCorrectionExplanation from './PassageCorrectionExplanation.react';
import PassageCorrectionInputArea from './PassageCorrectionInputArea.react';

const PassageCorrectionQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customHeader={customHeader}
      customExplanation={<PassageCorrectionExplanation question={activeQuestion} />}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={PassageCorrectionInputArea}
    />
  );
};

type PassageCorrectionQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const PassageCorrectionQuestion = {
  PreGuess: (props: PassageCorrectionQuestionTypeProps) => (
    <PassageCorrectionQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: PassageCorrectionQuestionTypeProps) => (
    <PassageCorrectionQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {PassageCorrectionQuestion};
